<template>
    <div>
        <el-alert type="success" :closable="false">
            <div slot="title">
                <div style="font-size:14px;" v-if="single.participant_number"> 该会议有<b>
                    {{ single.participant_number }} </b>人参与。<span v-if="single.live_viewers_num">另有<b>
                    {{ single.live_viewers_num }} </b>人观看直播。</span> <span v-if="mobile">请用电脑查看完整功能。</span>
                </div>
                <div style="font-size:14px;" v-else> 该会议无人参与。<span v-if="single.live_viewers_num">另有<b>
                    {{ single.live_viewers_num }} </b>人观看直播。</span></div>
            </div>
            <div>
                <el-button type="text" size="mini" @click="$emit('participant')" icon="el-icon-link"
                           v-if="!mobile">
                    下载参会报告
                </el-button>
                如果人数不正确，请点击
                <el-button type="text" size="mini" @click="$emit('rebuild')"><i
                    class="el-icon-refresh-right"></i> 重新刷新参会人员
                </el-button>
            </div>
        </el-alert>
        <div class="clearfix mb-3"></div>
        <el-table
            size="mini"
            :data="single.participants"
            :default-sort="{prop: 'date', order: 'asc'}"
            empty-text="没有参会者。"
        >
            <el-table-column
                label="姓名"
                prop="name">
            </el-table-column>
            <el-table-column
                label="时长"
                prop="minutes">
            </el-table-column>
            <el-table-column
                label="进入时间"
                v-if="!mobile"
            >
                <template #default="scope">
                    {{
                        scope.row.last_join_at ? (scope.row.first_join_at.slice(0, 16) + ' ~ '
                                + scope.row.last_join_at.slice(0, 11)
                                + scope.row.last_join_at.slice(scope.row.last_join_at.length > 23 ? -8 : -5).slice(0, 5)) :
                            scope.row.first_join_at
                    }}
                </template>
            </el-table-column>
            <el-table-column
                label="进入次数"
                prop="count">
            </el-table-column>
            <el-table-column
                label="得分"
                prop="score">
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
    name: 'meeting-view-visitor-info',
    props: {
        mobile: {
            type: Boolean,
            default: false
        },
        single: {
            type: Object,
            default() {
                return {}
            }
        }
    }
}
</script>
